export default __webpack_public_path__ + "static/shop_prints-cb18adf1b1a11209fc822a0e3bb03fc5.png";